import APIService from "./APIServices";
import { ApiToken } from "~/types/apiToken";


const TokenAPI = new APIService<ApiToken>("apiToken");

export const ApiTokenService = {
  getApiTokensData : TokenAPI.getAll,
  createApiToken : TokenAPI.create,
  deleteApiToken : TokenAPI.delete,
  updateApiToken : TokenAPI.update,
};
